import {colorBlack} from './color';

export const shadowNotification = `0 1px 2px 0 rgba(0, 0, 0, 0.17)`;
export const shadowSubtle = `0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)`;
export const shadowFirm = `0 0 6px ${colorBlack.toRGBA()}`;
